// angular import
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
// services import
import { AccountService } from './../../service/accountService.service';
import { Locale } from './../../service/locale.service';
import { ServerMapping } from './../../service/serverMapping.service';
// manager import
import { ModelsManager } from '../../manager/models.manager';
// models import
import { LotRequest } from './../../model/lot/lot_request.model';
import { LotResponse } from './../../model/lot/lot_response.model';
import { GrowlManager } from './../../manager/growl.manager';
import { DownloadManager } from './../../manager/download.manager';

@Injectable()
export class LotService {

  private searching = false;

  private lots = [];

  constructor(private accountService:     AccountService,
              private serverMapping:      ServerMapping,
              private growlManager:       GrowlManager,
              private downloadManager:    DownloadManager,
              private locale:             Locale,
              private http:               Http,
              private modelManager:       ModelsManager) {}

  isSearching() { return this.searching; }

  getLots() { return this.lots; }

  downloadExcel(a, b, c) {
    this.http.get(this.serverMapping.lotExcelDownloadURL +
        '?company_code=' + a +
        '&supplier_code=' + b +
        '&language=' + c).subscribe(
        (response) => {
          const data = response.json();
          if (this.growlManager.checkForErrorInResponse(data)) {
            this.growlManager.showMessagesByResponse(data);
          } else if (data.download) {
            this.downloadManager.prepareDownload(data.download.data, data.download.file_name, data.download.mime_type);
          }
          console.log(data);
        },
        (error) => {
          console.log('--------------------------------');
          console.log('!!!An error has been occurred!!!');
          console.log(error);
          console.log('--------------------------------');
        }
      );
    }

  searchLots() {
    if (this.searching === false) {
      this.searching = true;
      this.http.get(this.serverMapping.lotSearchURL +
        '?company_code=' + this.modelManager.lot_request.company_code +
        '&supplier_code=' + this.modelManager.lot_request.supplier_code +
        '&language=' + this.modelManager.lot_request.language).subscribe
        (
          (response) => {
            // store the response
            const data = response.json();
            if (this.growlManager.checkForErrorInResponse(data)) {
              this.growlManager.showMessagesByResponse(data);
            } else {
              this.lots = data.contained_bean;
            }

            this.searching = false;
          },
          (error) => {
            console.log('--------------------------------');
            console.log('!!!An error has been occurred!!!');
            console.log(error);
            console.log('--------------------------------');
          }
        );
    }
  }

  downloadPdf(lotNumber) {
    this.http.get(this.serverMapping.lotPrintURL +
      '?lot_number=' + lotNumber +
      '&language=' + this.modelManager.lot_request.language).subscribe(
      (response) => {
        const data = response.json();
        if (this.growlManager.checkForErrorInResponse(data)) {
          this.growlManager.showMessagesByResponse(data);
        } else if (data.download) {
          this.downloadManager.prepareDownload(data.download.data, data.download.file_name, data.download.mime_type);
        }
        console.log(data);
      },
      (error) => {
        console.log('--------------------------------');
        console.log('!!!An error has been occurred!!!');
        console.log(error);
        console.log('--------------------------------');
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/lot/lot.service.ts